import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Dropdown } from "react-bootstrap";
import PurchaseModuleModal from "../modals/PurchaseModuleModal";
import { validateUserRoleIds } from "../GlobalTools";

const canShowPremiumItem = validateUserRoleIds([1, 2]);

const MenuItemPremium = (props) => {
  // Destructure props
  const {
    serviceName,
    fromView,
    show = canShowPremiumItem,
    children = null,
    ...itemProps
  } = props;
  // Hooks
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  const handleClick = useCallback(() => {
    setShowPremiumModal(true);
  }, []);

  return show ? (
    <>
      <Dropdown.Item {...itemProps} onClick={handleClick}>
        {children}
        <i className="ms-2 fas fa-crown premiumColor" />
      </Dropdown.Item>
      {showPremiumModal && (
        <PurchaseModuleModal
          showModal={showPremiumModal}
          closeModal={() => setShowPremiumModal(false)}
          name={serviceName}
          originView={fromView}
        />
      )}
    </>
  ) : null;
};
MenuItemPremium.propTypes = {
  serviceName: PropTypes.string.isRequired,
  fromView: PropTypes.string.isRequired,
  children: PropTypes.node,
  show: PropTypes.bool,
};
export default MenuItemPremium;
